<template>
  <div id="layout-wrapper">
    <TopBar />
    <LeftSideBar :is-condensed="isMenuCondensed" />
    <div class="main-content">
      <div
        class="page-content"
        :class="{ 'dasboard-content': isDashboard === true }"
      >
        <!-- Start Content-->
        <div class="container-fluid">
          <slot />
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>
<script>
import router from '@/router';

import TopBar from '@/components/TopBar';
import LeftSideBar from '@/components/LeftSideBar';
import Footer from '@/components/Footer';

export default {
  data() {
    return {
      isMenuCondensed: false,
    };
  },
  components: {
    TopBar,
    LeftSideBar,
    Footer,
  },
  props: {
    isDashboard: {
      type: Boolean,
      default: false,
    },
  },
  created: () => {
    //document.body.classList.remove("bg-primary");
  },
  methods: {
    toggleMenu() {
      document.body.classList.toggle('sidebar-enable');

      //routeTo, routeFrom
      router.afterEach(() => {
        document.body.classList.remove('sidebar-enable');
        document.body.classList.remove('vertical-collpsed');
      });
      document.body.classList.toggle('vertical-collpsed');
      /*if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }*/
      this.isMenuCondensed = !this.isMenuCondensed;
    },
  },
};
</script>
